const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuariIdActivitatsAlumnes = async (id : string , id_projecte : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id}/activitats/${id_projecte}/alumnes`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
